export enum OverlayPosition {
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  RIGHT_TOP = 'right-top',
  RIGHT_BOTTOM = 'right-bottom',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
  LEFT_TOP = 'left-top',
  LEFT_BOTTOM = 'left-bottom',
}

export interface OverlayConfig {
  backgroundColor?: string;
  zIndex?: number;
  position?: OverlayPosition;
  content: HTMLElement;
}

export enum OverlayEvents {
  OVERLAY_OPEN = 'overlay-open',
  OVERLAY_CLOSE = 'overlay-close',
}
